/**
 * Popover direction
 */
export var PopoverDirection;
(function (PopoverDirection) {
    PopoverDirection["BOTTOM"] = "bottom";
    PopoverDirection["LEFT"] = "left";
    PopoverDirection["RIGHT"] = "right";
})(PopoverDirection || (PopoverDirection = {}));
/**
 * Popover arrow
 */
export var PopoverArrowPosition;
(function (PopoverArrowPosition) {
    PopoverArrowPosition["START"] = "start";
    PopoverArrowPosition["END"] = "end";
})(PopoverArrowPosition || (PopoverArrowPosition = {}));
//# sourceMappingURL=PopoverEnum.js.map